const afconQualifiersTNC = {
  header: "AFCON QUALIFIERS TRIVIA (DIGITAL) TERMS AND CONDITIONS",
  body: [
    {
      title: "SUMMARY OF THE PROMOTION",
      details: `The AFCON Qualifiers Trivia is a Digital based activity for MTN Pulse. It is a way of creating hype and also offering an exclusive experience for the Millennials and Gen-Zs using myMTN App to generate a ticket for the Ghana vs. Angola AFCON qualifiers match to support the Black Stars at the Baba Yara stadium in Kumasi. Eligible Pulse Winners will receive a free ticket for answering questions correctly on the myMTN App.`,
    },
    {
      title: "ELIGIBILITY",
      details: `To be eligible to enter this Trivia and claim the Prize (a free stadium ticket), each Participant must be under the age 35 years.`,
    },
    {
      title: ``,
      details: `MTN Pulse subscribers who use Smartphones across Ghana are eligible to participate in this digital football ticket trivia. `,
    },
    {
      title: " ",
      details: `There will be no opt in by way of USSD channel to participate in the trivia.`,
    },
    {
      title: "",
      details: `Participants must have a valid Ghana card and should be ready and willing to travel alone. `,
    },
    {
      title: ``,
      details: `TERMS`,
    },
    {
      title: ``,
      details: `The Trivia is valid from the 20th of March to the 22nd of March 2023.`,
    },
    {
      title: ``,
      details: `Eligible participants are to answer ALL questions correctly at a go to stand a chance of winning a ticket to support the Black Stars at the AFCON qualifiers match in Kumasi on the 23rd of March 2023.`,
    },
    {
      title: ``,
      details: `Eligible participants shall have two chances to answer the Trivia.`,
    },
    {
      title: ``,
      details: `Eligible participants will receive an In-App notification for qualifying for the ticket.`,
    },
    {
      title: ``,
      details: `The audited selection process to determine the winners is final and no correspondence will be entered into in relation to this.  In the event of a dispute, MTN’s decision is final and binding, and no further correspondence will be entertained.`,
    },
    {
      title: ``,
      details: `A ticket won is non-transferable non-refundable, cannot be exchanged for another item and cannot be redeemed for cash.`,
    },
    {
      title: ``,
      details: `A ticket admits only the winner(s) to watch the selected Ghana Black Stars match at AFCON qualifiers match in Kumasi.`,
    },
    {
      title: ``,
      details: `Selected winners are entitled to watch only One (1) match of the Ghana Black Stars during AFCON qualifiers fixtures.`,
    },
    {
      title: ``,
      details: `SIMs dedicated solely for commercial transactions by Mobile Money Agents and merchants and the owners of the SIMS are ineligible for this Trivia.`,
    },
    {
      title: ``,
      details: `MTN Staff and their spouses as well as third party agents are barred from this Trivia.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to disqualify a winner when it is proven that the winner used fraudulent means to participate in the Trivia. Such participants will be handed over to the police for prosecution.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to alter the Terms and Conditions at any point in time during the duration of the Trivia, and the Terms and Conditions as amended will be posted on MTN’s website.`,
    },
    {
      title: ``,
      details: `MTN shall not be liable where a force majeure/event beyond its control results in the annulment, shortening, extension or amendment of the Terms and Conditions of this Trivia. `,
    },
    {
      title: ``,
      details: `MTN shall not be liable to perform its obligations under this Trivia if the information provided by any winner is erroneous, incomplete or incorrect.`,
    },
    {
      title: ``,
      details: `A Participant hereby consents to MTN using and processing their personal information in accordance with the applicable data protection and privacy laws for processing of the Participant’s entry as stated in these Terms and Conditions, as well as for any marketing and promotions. The Participant may contact MTN in order to have their personal information verified, amended or removed from the MTN database.`,
    },
    {
      title: ``,
      details: `The personal data of the participants will be retained by MTN in accordance with the law and shall only be shared with the approved parties.`,
    },
    {
      title: ``,
      details: `Winners will be notified by MTN authorized personnel and via the number 0244 300 000 ONLY`,
    },
    {
      title: `DISCLAIMER`,
      details: `Selected Winners are responsible for fully adhering to all protocols (COVID-19, etc.) 
      required by AFCON, GFA, Stadium authorities and organizing committee. MTN, its respective directors, affiliates, members, partners, employees, agents, consultants, suppliers, contractors and subsidiaries, assume no liability whatsoever for any direct or indirect loss or damage, including but not limited to physical harm or death, howsoever arising from or as a result of a Participant’s participation in the Trivia in terms of this Competition and/or these Terms and Conditions. All Participants (including the winners) hereby expressly indemnify MTN, its respective directors, affiliates, members, 
      partners, employees, agents, consultants, suppliers, contractors, and in this regard and shall hold them harmless from all and any claims. `,
    },
    {
      title: `GOVERNING LAW`,
      details: `This Trivia shall be governed by the laws of Ghana.`,
    },
  ],
};

export default afconQualifiersTNC;
